import { render, staticRenderFns } from "./AccessoryItem.vue?vue&type=template&id=9052074c&scoped=true&"
import script from "./AccessoryItem.vue?vue&type=script&lang=js&"
export * from "./AccessoryItem.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryItem.vue?vue&type=style&index=0&id=9052074c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9052074c",
  null
  
)

export default component.exports